import { useState } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { useAuth } from '../../hooks/useAuth';
import { signOut } from '../../lib/api';

export default function Navbar({ onAddClick }) {
  const { user } = useAuth();
  const navigate = useNavigate();
  const location = useLocation();
  const [menuOpen, setMenuOpen] = useState(false);

  const tabs = [
    { path: '/', label: '🍽️ Testés', icon: '🍽️', short: 'Testés' },
    { path: '/a-tester', label: '📌 À tester', icon: '📌', short: 'À tester' },
    { path: '/carte', label: '🗺️ Carte', icon: '🗺️', short: 'Carte' },
  ];

  const isActive = (path) => location.pathname === path;

  async function handleSignOut() {
    await signOut();
    navigate('/auth');
  }

  const username = user?.user_metadata?.username || user?.email?.split('@')[0] || 'Moi';
  const initiale = username[0].toUpperCase();

  return (
    <>
      <nav style={{
        position: 'sticky', top: 0, zIndex: 100,
        background: 'rgba(255,255,255,0.92)', backdropFilter: 'blur(20px)',
        borderBottom: '1px solid var(--border)',
      }}>
        <div style={{ maxWidth: 1200, margin: '0 auto', padding: '0 20px', height: 62, display: 'flex', alignItems: 'center', gap: 8 }}>

          {/* Logo */}
          <div onClick={() => navigate('/')} style={{ cursor: 'pointer', display: 'flex', alignItems: 'center', gap: 8, marginRight: 16 }}>
            <span style={{ fontSize: 28 }}>🍜</span>
            <span style={{ fontFamily: 'var(--font-display)', fontWeight: 800, fontSize: 18, color: 'var(--brand)' }}>Foodies</span>
          </div>

          {/* Tabs desktop */}
          <div style={{ display: 'flex', gap: 4, flex: 1 }}>
            {tabs.map(tab => (
              <button key={tab.path} onClick={() => navigate(tab.path)} style={{
                padding: '7px 14px', borderRadius: 10, fontSize: 14, fontWeight: 600,
                background: isActive(tab.path) ? 'var(--brand-pale)' : 'transparent',
                color: isActive(tab.path) ? 'var(--brand)' : 'var(--text-2)',
                border: 'none', cursor: 'pointer', transition: 'all 0.2s',
              }}>
                <span style={{ display: 'flex', alignItems: 'center', gap: 6 }}>
                  {tab.icon} <span className="tab-label">{tab.short}</span>
                </span>
              </button>
            ))}
          </div>

          {/* Actions */}
          <div style={{ display: 'flex', alignItems: 'center', gap: 10 }}>
            {user && (
              <button onClick={onAddClick} style={{
                display: 'flex', alignItems: 'center', gap: 6,
                background: 'var(--brand)', color: '#fff',
                padding: '8px 16px', borderRadius: 10, fontSize: 14, fontWeight: 600,
                border: 'none', cursor: 'pointer',
                boxShadow: '0 4px 12px rgba(255,71,87,0.3)',
                transition: 'all 0.2s',
              }}>
                <span style={{ fontSize: 16, fontWeight: 300 }}>+</span>
                <span className="btn-add-label">Ajouter</span>
              </button>
            )}

            {/* Avatar + menu */}
            {user ? (
              <div style={{ position: 'relative' }}>
                <button onClick={() => setMenuOpen(!menuOpen)} style={{
                  width: 36, height: 36, borderRadius: '50%',
                  background: 'linear-gradient(135deg, var(--brand), var(--brand-light))',
                  color: '#fff', fontWeight: 700, fontSize: 14,
                  display: 'flex', alignItems: 'center', justifyContent: 'center',
                  border: 'none', cursor: 'pointer',
                }}>
                  {initiale}
                </button>
                {menuOpen && (
                  <div onClick={() => setMenuOpen(false)} style={{
                    position: 'absolute', right: 0, top: '44px',
                    background: 'var(--surface)', border: '1px solid var(--border)',
                    borderRadius: 14, boxShadow: 'var(--shadow-lg)', padding: '8px',
                    minWidth: 180, zIndex: 200, animation: 'scaleIn 0.15s ease',
                  }}>
                    <div style={{ padding: '8px 12px', borderBottom: '1px solid var(--border)', marginBottom: 4 }}>
                      <div style={{ fontSize: 13, fontWeight: 600 }}>{username}</div>
                      <div style={{ fontSize: 12, color: 'var(--text-3)' }}>{user.email}</div>
                    </div>
                    <button onClick={handleSignOut} style={{
                      width: '100%', padding: '8px 12px', textAlign: 'left',
                      fontSize: 14, color: '#EF4444', borderRadius: 8,
                      background: 'transparent', border: 'none', cursor: 'pointer',
                      display: 'flex', alignItems: 'center', gap: 8,
                    }}>
                      🚪 Déconnexion
                    </button>
                  </div>
                )}
              </div>
            ) : (
              <button onClick={() => navigate('/auth')} style={{ fontSize: 14, fontWeight: 600, color: 'var(--text-2)', background: 'var(--surface-3)', padding: '8px 16px', borderRadius: 10, border: 'none', cursor: 'pointer' }}>
                Connexion
              </button>
            )}
          </div>
        </div>
      </nav>

      <style>{`
        @media (max-width: 500px) {
          .tab-label { display: none; }
          .btn-add-label { display: none; }
        }
      `}</style>
    </>
  );
}
